import { ref } from 'vue';

export const confirmBus = {
  state: ref({
    show: false,
    message: '',
    onConfirm: null,
    onCancel: null,
  }),
  show(options) {
    this.state.value = {
      show: true,
      message: options.message || '你确定吗?',
      onConfirm: options.onConfirm || (() => {}),
      onCancel: options.onCancel || (() => {}),
    };
  },
  hide() {
    this.state.value.show = false;
  },
};